import React, {useState, useEffect} from 'react'
import {
    Segment,
    Form,
    Button,
    Dropdown
} from 'semantic-ui-react'
import {
    useHistory
  } from "react-router-dom";
import { loginUser, getPublicTranslations } from './LoginApi'
import axios from 'axios'
import { address } from '../../config'
import { getTranslation, getLoginLanguage, setLoginLanguage } from '../../translations'
import { getLanguageDropdownOptions } from '../../assets/languages'

const LoginComponent =()=> {
    const [login, setLogin] = useState('')
    const [password, setPassword] = useState('')
    const [valid, isValid] = useState(false)
    const [redirectPath, setRedirectPath] = useState('/forms')
    const [language, setUiLanguage] = useState(getLoginLanguage())
    const [availableLanguages, setAvailableLanguages] = useState(['pl', 'en'])
    const history = useHistory();
    const t = getTranslation(language)
    const languageOptions = getLanguageDropdownOptions(availableLanguages, { uiLanguage: language })

    useEffect(() => {
        axios.get(`${address}/test`)
            .then(res => {
                console.log(res.data)
            })
            .catch(err => {
                console.log(err)
            })
    }, [])

    useEffect(() => {
        getPublicTranslations()
            .then((data) => {
                localStorage.setItem('ahpCustomTranslations', JSON.stringify(data.translations || {}))
                const languages = (data.languages || []).length > 0 ? data.languages : ['pl', 'en']
                setAvailableLanguages(languages)
                if (!languages.includes(language)) {
                    const fallback = languages[0] || 'pl'
                    setLoginLanguage(fallback)
                    setUiLanguage(fallback)
                }
            })
            .catch(() => {
                setAvailableLanguages(['pl', 'en'])
            })
    }, [])

    useEffect(() => {
        if(valid) {
            history.push(redirectPath)
        }
    }, [valid, redirectPath, history])

    const handleLanguageChange = (languageCode) => {
        setLoginLanguage(languageCode)
        setUiLanguage(languageCode)
    }

    return(
    <div style={{height: '100vh', display: 'flex', justifyContent:'center', backgroundColor: '#fcf5f5'}}>
        <div style={{ width: 300, margin: 'auto' }}>
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 8 }}>
                <Dropdown
                    className='language-select'
                    selection
                    compact
                    search={languageOptions.length > 5}
                    options={languageOptions}
                    value={language}
                    onChange={(e, { value }) => handleLanguageChange(value)}
                    aria-label={t.login.selectLanguage}
                />
            </div>
            <Segment>
            <Form>
                <Form.Field>
                    <label>{t.login.title}</label>
                    <input 
                        onChange={(e)=> setLogin(e.target.value)}
                        value={login}
                        placeholder={t.login.loginPlaceholder} 
                        />
                </Form.Field>
                <Form.Field>
                    <label>{t.login.password}</label>
                    <input 
                        type='password'
                        onChange={(e)=> setPassword(e.target.value)}
                        value={password}
                        placeholder={t.login.passwordPlaceholder} 
                        />
                </Form.Field>
                <Button type='submit' onClick={async() => {
                    await loginUser(login, password, isValid, setRedirectPath)
                }}> 
                    {t.login.button}
                </Button>
            </Form>
            </Segment>
        </div>
    </div>
    )
}

export default LoginComponent
